export const gstSlab = ["0", "5", "18", "40"];

export const insuranceCompany = {
  MAD: 11,
};

export const storeType = ["Small", "Medium", "Large"];

export const LocationType = [
  "CorporateBuilding",
  "CoWorking",
  "BagpackerHostel",
  "College/University",
  "Salon/Spa",
  "Clinic",
  "Hospital",
  "RetailStore",
  "Mall",
  "Housing",
  "Hotel",
];

export const storageType = ["Ambient", "Chilled", "Frozen"];
export const deliveryType = ["To Store", "To Warehouse"];
export const recipeOrIngredient = ["Recipe", "Ingredient"];

export const companyStates = [
  {
    id: 8,
    state: "Rajasthan",
    gst: "08AARCA9982D1Z2",
    name: "ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
    address: "7, PARK HOUSE SCHEME, MI ROAD, JAIPUR, Jaipur, Rajasthan, 302001",
  },
  {
    id: 9,
    state: "Uttar Pradesh",
    gst: "09AARCA9982D1Z0",
    name: "ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
    address:
      "S-124, HARSHA COMPOUND, LONI ROAD, MOHAN NAGAR, Ghaziabad, Uttar Pradesh, 201007",
  },
  {
    id: 6,
    state: "Haryana",
    gst: "06AARCA9982D1Z6",
    name: "ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
    address:
      "1264f-1/FF, HOUSING BOARD COLONY, SECTOR-02,FARIDABAD, Faridabad, Haryana, 121004",
  },
  {
    id: 7,
    state: "Delhi",
    gst: "07AARCA9982D1Z4",
    name: "ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
    address: "C-39, EAST OF KAILASH, NEW DELHI, South Delhi, Delhi, 110065",
  },
  {
    id: 23,
    state: "Madhya Pradesh",
    gst: "23AARCA9982D1ZA",
    name: "ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
    address:
      "Village Bhadar, Lovekush Nagar, Laundi, Chhatarpur, Chhatarpur, Madhya Pradesh, 471515",
  },
];
